import { BareActionContext } from 'vuex-typex'
import { ConvoState } from '@/store/convo/state'
import { RootState } from '@/store'
import convoStore from '@/store/convo/convo-store'
import feedStore from '@/store/feed/feed-store'
import { ConvoSearchForm } from '@/model/search/search-query'
import setConvoQuery from '@/store/convo/actions/set-convo-query';

export default async function initFetchConvos(context: BareActionContext<ConvoState, RootState>)
{
    convoStore.state.convos = []
    convoStore.state.convoSearchForm = new ConvoSearchForm()
    const form = convoStore.state.convoSearchForm
    if (!feedStore.isCurrentUser) {
        form.createdByUser = true
    }

    setConvoQuery(context)

    return
}
